import { negatePrice } from "@@/shared/prices/negate-price";
import { repeat } from "@@/utilities/repeat";
import type { Price} from "./price";
import { zeroPrice } from "./price";
import { sumPrices } from "./sum-prices";

const multiplyPrice = (price: Price, multiplier: number): Price => {
    if (multiplier === 0) return zeroPrice;

    if (multiplier === 1) return price;

    if (multiplier < 0) return negatePrice(multiplyPrice(price, -multiplier));

    return sumPrices(repeat(price, multiplier));
};

export { multiplyPrice };
